import React from 'react'
import cx from 'classnames'
import styles from './PlusMinus.module.css'

type PlusMinusProps = {
    property: string
    value: string
    onChange: (property: string, value: string) => void
    classes?: string
    label: string
}

const PlusMinus: React.FC<PlusMinusProps> = ({
    property,
    value = '#fc0',
    onChange,
    label,
    classes,
}) => {
    const handleValueChange = (val: number) => {
        onChange(property, (parseInt(value) + val).toString())
    }

    return (
        <div className={cx(styles['wrapper'], classes)}>
            <span>{label}:</span>
            <div className={'zr-position-relative zr-d-flex'}>
                <button
                    type={'button'}
                    className={cx(styles['circle'])}
                    onClick={() => handleValueChange(1)}
                >
                    +
                </button>
                <button
                    type={'button'}
                    className={cx(styles['circle'])}
                    onClick={() => handleValueChange(-1)}
                >
                    &#8722;
                </button>
            </div>
        </div>
    )
}

export default PlusMinus
